export default __webpack_public_path__ + "static/loading-floors.2f3e056958ca471dcf9ae464122558d3.svg";